<script lang="ts">
	import Tag from './tag.svelte';

	let { note }: { note: App.Thought } = $props();
</script>

<div
	style="display: grid; column-gap: 1em; row-gap: 0.5em; margin-bottom: 1em; grid-columns: masonry; grid-rows: autofill 1.5em"
>
	{#each note.tags as tag}
		<Tag rawTag={tag} />
	{/each}
</div>
